/** Refx Booking configuration name */
export const COMPONENTS_CONFIGURATION_NAME = '@refx/booking';
